import React from 'react';
import { DrawerContext, InfoRewardsContext } from '../../../../contexts';
import { ExpirationLine, LoadingSkeletonVertical, RewardsTileDTW, RewardsTileMW, } from '../../../shared/rewards-hub';
import { assets } from '../../../../images/AssetPaths';
import { ChallengeSentence } from '../../Drawer/ChallengeDrawer/ChallengeTile';
import { ChallengeStepper } from '../../Drawer/ChallengeDrawer/ChallengeStepper';
import { useIsMobile } from '../../../../hooks';
import { rhGeneral, rhTierRewards } from '../../../../constants/RewardsHub';
import { useDisplayAmount } from '../../../../utils/PerkOptionsUtil';
import { DrawerEventTriggers } from '../../../../utils/DrawerEventUtils';
var useGetIsMobile = function () { return useIsMobile().isMobile; };
var constants = rhTierRewards.perkRewards;
var imgAssets = rhGeneral.assets;
export var LoadingTile = function () { return (React.createElement("div", { className: "sui-mb-6" },
    React.createElement(LoadingSkeletonVertical, { isMobile: useGetIsMobile(), hideBlock: true, hideLines: !useGetIsMobile(), disablePadding: true, lineCountDTW: 2, lineCountMW: 2 }))); };
export var AvailableRewardsTile = function (_a) {
    var reward = _a.reward, isMobile = _a.isMobile, inListDrawer = _a.inListDrawer;
    var _b = React.useContext(DrawerContext), openDetailsPerks = _b.openDetailsPerks, openDetailsOffers = _b.openDetailsOffers, onDrawerClose = _b.onDrawerClose, onBackFromPAC = _b.onBackFromPAC, setDrawerOpen = _b.setDrawerOpen, isPacDrawersEnabled = _b.isPacDrawersEnabled;
    var getDisplayAmount = useDisplayAmount();
    var RewardsTile = isMobile ? RewardsTileMW : RewardsTileDTW;
    var eventOutput = {
        perkObj: reward,
        onClose: onDrawerClose,
        onBack: inListDrawer && (function () { return onBackFromPAC('RewardsList'); }),
    };
    var onClick = function () {
        if (isPacDrawersEnabled) {
            if (inListDrawer)
                setDrawerOpen(false);
            DrawerEventTriggers.triggerRewardBarcodeDrawer(eventOutput);
        }
        else if (isOffer)
            openDetailsOffers({ perk: reward, eventOutput: eventOutput, showBack: inListDrawer });
        else
            openDetailsPerks({ perk: reward, eventOutput: eventOutput, showBack: inListDrawer });
    };
    // All offers have the reward type of offer, but not all perks have the reward type of perk
    var isOffer = (reward === null || reward === void 0 ? void 0 : reward.offerType) === 'OFFER';
    return (React.createElement(RewardsTile, { title: "".concat(getDisplayAmount(reward)).concat(reward.perkTitle), subtitle: React.createElement(ExpirationLine, { perk: reward, type: isOffer ? 'Offer' : 'Perk' }), iconUrl: reward.perkImageUrl, containerCallback: onClick, inListDrawer: inListDrawer, type: "available" }));
};
export var NewUnlockedTile = function (_a) {
    var _b;
    var reward = _a.reward, isMobile = _a.isMobile, inListDrawer = _a.inListDrawer;
    var RewardsTile = isMobile ? RewardsTileMW : RewardsTileDTW;
    var _c = React.useContext(DrawerContext), openSelectionPerks = _c.openSelectionPerks, onDrawerClose = _c.onDrawerClose, onBackFromPAC = _c.onBackFromPAC, setDrawerOpen = _c.setDrawerOpen, isPacDrawersEnabled = _c.isPacDrawersEnabled;
    var perksInfo = React.useContext(InfoRewardsContext).rewardsInfo;
    var eventOutput = {
        tierObj: reward,
        onClose: onDrawerClose,
        onBack: inListDrawer && (function () { return onBackFromPAC('RewardsList'); }),
        programId: (_b = perksInfo === null || perksInfo === void 0 ? void 0 : perksInfo.program) === null || _b === void 0 ? void 0 : _b.programId,
    };
    var onClick = function () {
        if (isPacDrawersEnabled) {
            if (inListDrawer)
                setDrawerOpen(false);
            DrawerEventTriggers.triggerPerkSelectionDrawer(eventOutput);
        }
        else
            openSelectionPerks({ perk: reward, eventOutput: eventOutput });
    };
    return (React.createElement(RewardsTile, { title: constants.newUnlocked, subtitle: React.createElement(ExpirationLine, { perk: reward, type: "Perk" }), iconUrl: imgAssets.badge_unlocked, containerCallback: onClick, inListDrawer: inListDrawer, isMobile: isMobile, type: "unlocked" }));
};
export var ChallengeTile = function (_a) {
    var _b;
    var challenge = _a.challenge, isMobile = _a.isMobile, inListDrawer = _a.inListDrawer;
    var _c = React.useContext(DrawerContext), setDrawerOpen = _c.setDrawerOpen, setBack = _c.setBack, setDrawerType = _c.setDrawerType;
    var RewardsTile = isMobile ? RewardsTileMW : RewardsTileDTW;
    return (React.createElement(RewardsTile, { title: challenge === null || challenge === void 0 ? void 0 : challenge.name, subtitle: React.createElement(ChallengeSentence, { challenge: challenge }), iconUrl: (_b = challenge === null || challenge === void 0 ? void 0 : challenge.imageUrl) !== null && _b !== void 0 ? _b : assets.cardIcons.ChallengeIcon, containerCallback: function () {
            if (inListDrawer) {
                setBack(true);
            }
            setDrawerType('ChallengeDetails');
            setDrawerOpen(true);
        }, isMobile: isMobile, inListDrawer: inListDrawer, type: "challenge" },
        React.createElement(ChallengeStepper, { steps: challenge === null || challenge === void 0 ? void 0 : challenge.challengeSteps, inListDrawer: true, activeStep: challenge === null || challenge === void 0 ? void 0 : challenge.challengeStepsCompleted })));
};
